/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AbstractCommand } from '../AbstractCommand';
import { ICommand } from '../ICommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';

/**
 * A command used to aggregate an array of other commands into a single logical command.  This is used
 * for example to make multiple changes as a single "undoable" change.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class AggregateCommand extends AbstractCommand {
    public name : string;

    public info : any;

    public _commands : Array<ICommand>;

    public constructor(name? : any, info? : any, commands? : any) {
        if(((typeof name === 'string') || name === null) && ((info != null) || info === null) && ((commands != null && (commands instanceof Array)) || commands === null)) {
            let __args = arguments;
            super();
            if(this.name===undefined) this.name = null;
            if(this.info===undefined) this.info = null;
            if(this._commands===undefined) this._commands = null;
            if(this.name===undefined) this.name = null;
            if(this.info===undefined) this.info = null;
            if(this._commands===undefined) this._commands = null;
            (() => {
                this.name = name;
                this.info = info;
                this._commands = commands;
            })();
        } else if(name === undefined && info === undefined && commands === undefined) {
            let __args = arguments;
            super();
            if(this.name===undefined) this.name = null;
            if(this.info===undefined) this.info = null;
            if(this._commands===undefined) this._commands = null;
            if(this.name===undefined) this.name = null;
            if(this.info===undefined) this.info = null;
            if(this._commands===undefined) this._commands = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[AggregateCommand] Executing %d child commands.", /* size */(<number>this._commands.length));
        this._commands.forEach((command) => {
            command.execute(document);
        });
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[AggregateCommand] Reverting %d child commands.", /* size */(<number>this._commands.length));
        for(let idx : number = /* size */(<number>this._commands.length) - 1; idx >= 0; idx--) {{
            let command : ICommand = /* get */this._commands[idx];
            command.undo(document);
        };}
    }
}
AggregateCommand["__class"] = "io.apicurio.datamodels.cmd.commands.AggregateCommand";
AggregateCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];





import { MarshallCompat } from '../../compat/MarshallCompat';

